
<template>
  <page-list
    :list="list"
    :columns="columns"
    :single-actions="singleActions"
    :export-data-options="exportDataOptions" />
</template>

<script>
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'
import { getNameFilter } from '@/utils/common/tableFilter'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'ChannelList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, SingleActionsMixin],
  props: {
    id: String,
    getParams: {
      type: [Function, Object],
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'customers',
        getParams: {
          is_agent: true,
        },
        filterOptions: {
          enterprise_name: getNameFilter(),
          name: {
            label: this.$t('scope.text_322'),
            filter: true,
            formatter: val => {
              return `name.contains(${val})`
            },
          },
          mobile: {
            label: this.$t('scope.text_494'),
            filter: true,
            formatter: val => {
              return `mobile.contains(${val})`
            },
          },
          agent_level: {
            label: this.$t('scope.text_495'),
            dropdown: true,
            items: [
              { label: this.$t('scope.text_496'), key: '0' },
              { label: this.$t('scope.text_497'), key: '1' },
            ],
            filter: true,
            formatter: val => {
              return `agent_level.in(${val})`
            },
          },
        },
        responseData: this.responseData,
      }),
      exportDataOptions: {
        items: [
          { label: this.$t('scope.text_318'), key: 'enterprise_name' },
          { label: this.$t('scope.text_431'), key: 'email' },
          { label: this.$t('scope.text_322'), key: 'user_name' },
          { label: this.$t('scope.text_494'), key: 'mobile' },
          { label: this.$t('scope.text_327'), key: 'memo' },
          { label: this.$t('scope.text_498'), key: 'created_at' },
          { label: this.$t('scope.text_495'), key: 'agent_level' },
        ],
      },
    }
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'ChannelManagerSidePage', {
        id: row.id,
        resource: 'customers',
      }, {
        list: this.list,
      })
    },
  },
}
</script>
